import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceDashboardPageComponent } from './device-dashboard-page.component';

const routes: Routes = [
  {
    path: 'device-dashboard',
    data: { name: 'Device Dashboard', isTab: false },
    component: DeviceDashboardPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceDashboardPageRoutingModule {}
